import { createSelector } from 'reselect'
import { Store } from '../types'

export const loadingSelector = (store: Store) => store.loading
export const anyLoadingSelector = createSelector(loadingSelector, loading => Object.values(loading).some(v => v))
